import { Box, Button, useClipboard } from "@chakra-ui/react"
import { FC } from "react"
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter"
import { darcula } from "react-syntax-highlighter/dist/cjs/styles/prism"

interface CodeBlockProps {
  code: string
  language: string
}

const CodeBlock: FC<CodeBlockProps> = ({ code, language }) => {
  const { hasCopied, onCopy } = useClipboard(code)

  return (
    <Box position={"relative"}>
      <Button
        size={"xs"}
        fontFamily="monospace"
        fontWeight="bold"
        position={"absolute"}
        right={"2"}
        top={"2"}
        onClick={onCopy}
      >
        {hasCopied ? "copied" : "copy"}
      </Button>
      <SyntaxHighlighter language={language} style={darcula}>
        {code}
      </SyntaxHighlighter>
    </Box>
  )
}

export default CodeBlock
